var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page 401-page"},[_vm._m(0),_c('p',[_vm._v("You are not authorized to access the page you requested.")]),_c('div',[_c('a',{staticClass:"btn btn-light",on:{"click":function($event){return _vm.logout()}}},[_vm._v("Log out")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("401 Forbidden")])])
}]

export { render, staticRenderFns }